import { ReportStatus } from '@/__generated__/graphql';

type Label = {
  [key in ReportStatus]: {
    title: string;
    description: string;
    confirmButtonText: string;
    cancelButtonText: string;
  };
};

export const REPORT_UPDATE_DIALOG_LABELS: Label = {
  [ReportStatus.Draft]: {
    title: 'Publishing Report',
    description:
      'Are you sure you want to publish this report? Once the report is published, you will not be able to edit the report.',
    confirmButtonText: 'Publish report',
    cancelButtonText: 'Cancel',
  },
  [ReportStatus.Published]: {
    title: 'Close Report',
    description: 'Are you sure you want to close this report?',
    confirmButtonText: 'Close report',
    cancelButtonText: 'Cancel',
  },
  [ReportStatus.Deleted]: {
    title: '',
    description: '',
    confirmButtonText: '',
    cancelButtonText: '',
  },
  [ReportStatus.Closed]: {
    title: '',
    description: '',
    confirmButtonText: '',
    cancelButtonText: '',
  },
};
